import ReportsLayout from "@/app/(app)/(crew)/reports/_layout";

export default ReportsLayout;
